import styled from 'styled-components';

export const Center = styled.p`
  text-align: center;
  font-size: 1rem;
  color: var(--text-light);
`;
